export class GradeDetails {
  name: string;
  timesAchieved: number;
  private _rangeTo: number = 0;

  get rangeTo() { return this._rangeTo; }
  set rangeTo(val: any) { this._rangeTo = Number(val); }

  private _rangeFrom: number = 0;

  get rangeFrom() { return this._rangeFrom; }
  set rangeFrom(val: any) { this._rangeFrom = Number(val); }

  constructor(title: string, timesAchieved = 0, maxRange = 0, minRange = 0) {
    this.name = title;
    this.timesAchieved = timesAchieved;
    this.rangeTo = maxRange;
    this.rangeFrom = minRange;
  }

  isValid(): boolean {
    return null != this.name.trim() && this.markValid() && this.markRangeValid() && this.timesAchievedRangeValid();
  }

  markValid(): boolean {
    return this.validRangeFrom() && this.validRangeTo();
  }

  validRangeFrom(): boolean {
    return this.rangeFrom >= 0 && this.rangeFrom <= 120;
  }

  validRangeTo(): boolean {
    return this.rangeTo >= 0 && this.rangeTo <= 120;
  }

  markRangeValid(): boolean {
    return this.rangeFrom < this.rangeTo;
  }

  timesAchievedRangeValid(): boolean {
    return this.timesAchieved >= 0 && this.timesAchieved <= 99;
  }
}
